const map = {
    roleType: {
        1: '菜单',
        2: '按钮',
        3: '导航'
    },
    menuStatus: {
        1: '正常',
        0: '删除',
        2: '停用 '
    },
    checkStatus: {
        1: "应答成功",
        0: "应答失败",
        2: "查岗中"
    },
    deviceStatus: {
        1: '在线',
        0: '离线'
    },
    bjType: {
        "firecompany": "火警单位",
        "errcompany": "故障单位",
        "defindcompany": "屏蔽单位",
        "watercompany": "水系统",
        "electcompany": "电气监控",
        "wifismokecompany": "无线烟感",
        "wififirecompany": "无线燃气",
        'lowGasLowCompany': "燃气低浓度",
        'highGasCompany': '燃气高浓度'

    },
    bjStatus: {
        fire: "火警",
        err: "故障",
        ping: "屏蔽",
        on: "复位",
        monitor: "监管",
        start: "启动",
        reset: "反馈",
        rever: "恢复",
        handfire: "手动报警",
        common: "通用",
        other: "超限",
        loudian: "漏电",
        ranqidi: "燃气低浓度",
        ranqigao: "燃气高浓度",
        pengzhuang: "碰撞告警",
        xiaxian: "下限告警",
        fireOn: "气体灭火启动",
        fireOff: "气体灭火停止",
        paichu: "排除",
        qita: "其他"
    },
    leftStatus: {
        fire: "火警",
        err: "故障",
        ping: "屏蔽",
        on: "复位",
        monitor: "监管",
        start: "启动",
        reset: "反馈",
        rever: "恢复",
        handfire: "手动报警",
        common: "通用",
        water: "水系统",
        loudian: "漏电",
        gaowen: '高温',
        ranqidi: "燃气低浓度",
        ranqigao: "燃气高浓度",
        pengzhuang: "碰撞告警",
        xiaxian: "下限告警",
        fireOn: "气体灭火启动",
        fireOff: "气体灭火停止",
    },
    unitMap: {
        network: '联网单位',
        report: '报备单位',
        test: '测试单位',
        monitor: '监控单位',
        close: '关机单位'
    },
    unitType: {
        2: '联网单位',
        3: "消防监管单位",
        4: "维保单位",
        5: "其他单位"
    },
    pgstatus: {
        0: "评估中",
        1: "已完成"
    },
    sexStatus: {
        1: '男',
        2: "女"
    },
    safeState: {
        1: "启用",
        0: "停用"
    },
    //巡查点状态
    checkstates: {

        1: '正常',
        2: '待审核',
        3: '待复核',
        4: '待整改',
        5: '已整改'
    },
    checkstates1: {

        '1': '正常',
        '2': '待审核',
        '3': '待复核',
        '4': '待整改',
        '5': '已整改'
    },
    isNormal: {
        0: "正常",
        1: '异常',
        2: '当场整改'
    },
    // 监管单位
    jgjb: {
        40: "火灾高危单位",
        41: "重点单位",
        39: "一般单位",
        42: "九小场所",
        0: '',
    },
    menu_icon: {
        "基础设置": 'el-icon-setting',
        "查岗": "el-icon-monitor",
        "报表管理": 'el-icon-pie-chart',
        "巡查管理": "el-icon-map-location",
        "小程序": 'el-icon-picture-outline-round'
    },
    //文物隐患

    wenwudanger: {
        1: "已整改",
        0: "隐患"
    },
    NFCStatus: {
        1: '二维码标识',
        2: 'NFC标识',
        3: '二维码和NFC'
    },
    // 预案分组
    planGroup: {
        1: "zhihui",
        2: "miehuo",
        3: "shusan",
        4: "jiuhu",
        5: "jingjie",
        6: "baozhang",
        7: "jidong",
        8: "lianluo"
    },
    groupPlan: {
        "zhihui": 1,
        "miehuo": 2,
        "shusan": 3,
        "jiuhu": 4,
        "jingjie": 5,
        "baozhang": 6,
        "jidong": 7,
        "lianluo": 8
    },
    crtIcon: {
        // 226: { 1: 'comra_top.png', 2: 'comra_bottom.png', 3: 'comra_left.png', 4: 'comra.png', 5: 'comra_upper_left.png', 6: 'comra_lower_left.png', 7: 'comra_upper_right.png', 8: 'comra_lower_right.png' },
        226: 'comra.png', // 摄像头
        227: 'yangan.png',// 烟感
        228: "wengan.png",//温感
        229: "shoubao.jpg",//手报
        230: 'xiaohuoshuan.jpg', // 消火栓手报
        231: "shuiliu.jpg", // 水流
        177: "point.png",
        238: "fan.png",
        240: "pai.png",
        280: { 1: 'normal_top.png', 2: 'normal_bottom.png', 3: 'normal_left.png', 4: 'normal_right.png', '1,2': 'normal_topAB.png', '3,4': 'normal_leftAB.png', 7: 'normal_escape.png' },
        2801: { 1: 'fault_top.png', 2: 'fault_botoom.png', 3: 'fault_left.png', 4: 'fault_right.png', '1,2': 'fault_topAB.png', '3,4': 'fault_leftAB.png', 7: 'fault_escape.png' },
        2802: { 1: 'flicker_top.gif', 2: 'flicker_bootom.gif', 3: 'flicker_left.gif', 4: 'flicker_right.gif', '1,2': 'flicker_topAB.gif', '3,4': 'flicker_leftAB.gif', 7: 'flicker_escape.gif' },
        2803: { 1: 'close_top.png', 2: 'close_bottom.png', 3: 'close_left.png', 4: 'close_right.png', '1,2': 'close_topAB.png', '3,4': 'close_leftAB.png', 7: 'close_escape.png' },
    },
    serviceType: {
        '1': "评估",
        '2': "维保",
        '3': "监控",
        '4': "电检",
        '5': "消检",
        '6': "验收",
        '7': "电气监控",
        '8': "巡查",
    },
}

export default map
